import core from '~/core/scripts';
import React from 'react';
import ReactDOM from 'react-dom';
import ChoroplethMapWidget from '~/core/scripts/widgets/ChoroplethMapWidget';
import TableWidget from '~/core/scripts/widgets/TableWidget';
import TableWidgetChooser from '~/core/scripts/widgets/TableWidget/Chooser';
import '../styles/index.styl';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();
//console.log("hello");

const mapContainer = document.getElementById('map');
const basemapAttribution = 'Karte: <a href="https://www.maptiler.com/license/maps/" target="_blank">© MapTiler</a> <a href="https://www.openstreetmap.org/copyright" target="_blank">© OpenStreetMap contributors</a>';

if (mapContainer) {
  ReactDOM.render((
    <ChoroplethMapWidget
      minZoom={5}
      maxZoom={14}
      choroplethSource="data/miete_gehalt.topo.json"
      overlaySource="data/miete_gehalt.topo.json"
      overlayDissolveKey="Bundesland"
      showBasemap
      //basemapUrl="https://api.maptiler.com/maps/ab703975-6307-4e09-8543-45501e7bcb41/256/{z}/{x}/{y}@2x.png?key=68ErAz6zqgdV9jEjhpuz"
      basemapAttribution={basemapAttribution}
      showOverlaymap
      overlaymapUrl="https://api.maptiler.com/maps/ab703975-6307-4e09-8543-45501e7bcb41/256/{z}/{x}/{y}@2x.png?key=68ErAz6zqgdV9jEjhpuz"
      overlaymapAttribution={basemapAttribution}
      showGeocoder
      valueKey="dif_2014_2018"
      colorSteps={[
        [-24,'#701a2d'], // -25 bis -15
        [-15, '#aa2c41'], 
        [-10, '#d7545c'], 
        [-8, '#f5857f'], 
        [-5, '#ffbeaa'], 
        [-1, '#fff5d9'], // diese Farbe geht von -1 bis 1 
        [1, '#bed3ce'], 
        [5, '#82b1bc'], 
        [8, '#4d8da5'], 
        [10, '#1f6a8a'], 
        [14]
      ]}
      showLegend
      legendMinLabel="-24%"
      legendMaxLabel="+14%"
      showLabels
      //labelPreset="germany"
      customLabels={[]}
      searchPresets={[
        { name: 'Berlin',  locationId: 'NT_DKX2wfaWICS7JyfHmCOJhB' }, 
        { name: 'Essen',   locationId: 'NT_tnooK1H86B2f1a8KK1KcZD' }, 
        { name: 'Hamburg', locationId: 'NT_B2OmyxxaannVowGpd3M-nA' },
        { name: 'Erfurt',  locationId: 'NT_bLltyZaK6FkaVrBD-Lu.iA' }
      ]}
      searchPresetsTitle="Zum Beispiel:"
      smoothFactor={0.5}
      // zoomDelta={1}
      zoomSnap={0.5}
      zoomAfterGeocode={10}
    />
  ), mapContainer);
}

// table
const tableContainer = document.getElementById('table');

if (tableContainer) {

  const columns = [{
    title: 'Region', 
    dataIndex: 'name'
  },{
    title: 'Löhne', dataIndex: 'gehalt', percentage: true, icon: 'wage', className: 'icon-wage'
  },{ 
    title: 'Mieten', dataIndex: 'miete', percentage: true, icon: 'house', className: 'icon-house'
  },{ 
    title: 'Differenz', dataIndex: 'dif', percentagebar: true, barColor: '#F4777F', className: 'col-diff'
  }];

  ReactDOM.render((
    <TableWidgetChooser>
      <TableWidget
        dataSource="data/miete_gehalt.csv"
        columns={columns}
        sortColumn="dif"
        sortDirection="asc"
        showRank
        showUntil={10}
        label="erschwinglicher"
        className="decrease"
        infoText="Hier steigen die Löhne deutlich schneller als die Mieten"
        rankColor="#4771B2"
      />
      <TableWidget
        dataSource="data/miete_gehalt.csv"
        columns={columns}
        sortColumn="dif"
        sortDirection="desc"
        showRank
        showUntil={10}
        label="weniger erschwinglich"
        className="increase"
        infoText="Hier steigen die Mieten deutlich schneller als die Löhne"
        rankColor="#F4777F"
      />
    </TableWidgetChooser>
  ), tableContainer);
}


// this is just for development purposes -> if we are looking at a layout-sample,
// we check if there is a corresponding js file
if (process.env.NODE_ENV === 'development') {
  // enable livereload for index html
  require('file-loader!../index.html');

  if (location.pathname.includes('.html')) {
    const fileToLoad = location.pathname.replace('.html', '.js');
    try {
      require(`../layout-samples${fileToLoad}`);
    } catch(e) {
      console.log(e);
      console.log(`[Starterkit] no file found ${fileToLoad}`);
    }
  }
}